module.exports = __webpack_public_path__ + "img/月亮日記標題圖片.da35f4cf.svg";